import axios from "axios";
import { Button } from "react-bootstrap";
import { getAxiosHeader } from "../../api";
import * as config from '../../common/config/config';
import { customFormatDate } from "../../common/utils/date";
import { createFilterStructure, createPayload } from "../../common/utils/pagination";
import { InvoiceIcetexReport } from "../../interfaces/invoiceIcetex.interface";
import { PaginationType } from "../../interfaces/response.interface";
import { ColumnType, PaginationModel, TableModel } from "../../interfaces/table.interface";

export interface InvoiceIcetexFilterModel {
    applicantId?: string;
    email?: string;
    ticket?: string;
    dateRange?: {
        startDate?: string;
        endDate?: string;
    }
}

export const defaultPagination: PaginationModel = {
    page: 1,
    limit: 10
}

export const createFilterModel = (
    { applicantId, email, dateRange, ticket }:
        InvoiceIcetexFilterModel) => {

    const filterIdentificationCard = createFilterStructure(
        'applicantId',
        'contains',
        applicantId,
    );
    const filterEmail = createFilterStructure(
        'email',
        'contains',
        email,
    );
    const filterTicket = createFilterStructure(
        'ticket',
        'contains',
        ticket,
    );

    let modelFilter = [
        filterIdentificationCard,
        filterEmail,
        filterTicket
    ].filter((item) => item);

    if (dateRange?.startDate && dateRange?.endDate) {
        console.log('dateRange', dateRange)
        const filterDateRange = createFilterStructure(
            'sending_date',
            'between_date',
            dateRange,
        );

        modelFilter = [
            ...modelFilter,
            filterDateRange
        ]
    }

    return modelFilter;
}

export const getColumns: (onDetail: (id: number, applicantId: string) => void)
    => ColumnType<InvoiceIcetexReport>[] =
    (onDetail) => {
        const columns = [
            {
                field: 'applicantId',
                headerName: 'Documento Id',
            },
            {
                field: 'email',
                headerName: 'Email',

            },
            {
                field: 'referenceCode',
                headerName: 'Codigo de referencia',
            },
            {
                field: 'ticket',
                headerName: 'Ticket',
            },
            {
                field: 'cutDate',
                headerName: 'Fecha de corte',
                render: ({ cutDate }) =>
                    customFormatDate(cutDate, "PP"),
            },
            {
                field: 'id',
                headerName: 'Factura',
                render: ({ id, applicantId }) => {
                    return (
                        <Button
                            className="bi bi-filetype-pdf"
                            onClick={() => onDetail(id, applicantId)}
                            variant="link"
                        ></Button>
                    )
                }
            },
        ]
        return columns;
    };

export const onFetchInvoiceIcetexData = async (
    pagination: TableModel<InvoiceIcetexReport>
) => {
    const url = `${config.BACKEND_URL}/api/v1/icetex/invoice${createPayload(pagination)}`;
    const response = await axios.get<PaginationType<InvoiceIcetexReport>>(url, getAxiosHeader());
    return response;
}

export const onFetchGetPdfInvoiceIcetexData = async (id: number) => {
    const url = `${config.BACKEND_URL}/api/v1/icetex/getInovice/${id}`;
    const header = getAxiosHeader();
    header.responseType = 'blob';
    const response = await axios.get<any>(url, header);
    return response;
}
